import {
  AmountDimension,
  CalendarDateDimension,
  ExclusionDimension,
  FinancialRateWithUnsetDimension,
  StringsEnumDimension,
} from '@orus.eu/dimensions'
import { mutaProductVersions } from '@orus.eu/product'

export const mutaProductVersionDimension = new StringsEnumDimension({
  name: 'mutaProductVersion',
  displayKeys: { name: 'dimension_name_muta_product_version' },
  values: mutaProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mutaYearlyBasePremiumDimension = new AmountDimension({
  name: 'mutaYearlyBasePremium',
  displayKeys: { name: 'dimension_name_muta_yearly_base_premium' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mutaYearlyTaxesDimension = new AmountDimension({
  name: 'mutaYearlyTaxes',
  displayKeys: { name: 'dimension_name_muta_yearly_taxes' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mutaYearlyTotalPremiumDimension = new AmountDimension({
  name: 'mutaYearlyTotalPremium',
  displayKeys: { name: 'dimension_name_muta_yearly_total_premium' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: true,
  inputLocking: undefined,
} as const)

export const mutaYearlyTotalAssistancePremiumDimension = new AmountDimension({
  name: 'mutaYearlyTotalAssistancePremium',
  displayKeys: { name: 'dimension_name_muta_yearly_total_assistance_premium' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mutaYearlyTotalNetworkPremiumDimension = new AmountDimension({
  name: 'mutaYearlyTotalNetworkPremium',
  displayKeys: { name: 'dimension_name_muta_yearly_total_network_premium' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mutaYearlyTotalAssociationPremiumDimension = new AmountDimension({
  name: 'mutaYearlyTotalAssociationPremium',
  displayKeys: { name: 'dimension_name_muta_yearly_total_association_premium' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mutaPricingMultiplierDimension = new FinancialRateWithUnsetDimension({
  name: 'mutaPricingMultiplier',
  displayKeys: { name: 'dimension_name_muta_pricing_multiplier' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
  configuration: {
    min: 0,
    max: 5,
    step: 0.000001,
  },
} as const)

export const mutaExclusionsDimension = new ExclusionDimension({
  name: 'mutaExclusions',
  displayKeys: { name: 'dimension_name_muta_exclusions' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
})

/** The earliest start date that leaves Care time to terminate the previous contract, set only while the start date is earlier */
export const mutaPreviousContractTerminationEarliestStartDateDimension = new CalendarDateDimension({
  name: 'mutaPreviousContractTerminationEarliestStartDate',
  displayKeys: { name: 'dimension_name_muta_previous_contract_termination_earliest_start_date' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
